export enum GoodPracticeTranslationOrigin {
  O = 'O', // Originally encoded by member state.
  T = 'T', // Encoded by translator.
}
